// Browser translators (Google Translate) swap React's text nodes for <font> wrappers, so React's
// next removeChild/insertBefore on them throws and crashes the page. https://github.com/facebook/react/issues/11538
export function installTranslationDomGuard() {
  if (typeof window === 'undefined') return;

  const removeChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function <T extends Node>(this: Node, child: T): T {
    return child.parentNode === this ? (removeChild.call(this, child) as T) : child;
  };
  const insertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function <T extends Node>(
    this: Node,
    node: T,
    ref: Node | null
  ): T {
    return insertBefore.call(this, node, ref?.parentNode === this ? ref : null) as T;
  };
}
